import { render, staticRenderFns } from "./ExportsSettings.vue?vue&type=template&id=3c89983b&"
import script from "./ExportsSettings.vue?vue&type=script&lang=js&"
export * from "./ExportsSettings.vue?vue&type=script&lang=js&"
import style0 from "./ExportsSettings.vue?vue&type=style&index=0&id=3c89983b&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports